<template>
   <div class="product-gallery-page">
      <!--Banner-->
      <div ref="productEleHeight" class="product">
         <h1 class="product__heading">{{ pageData.introduction.header }}</h1>
         <div ref="setImageHeight" class="product__image">
            <img
               :src="pageData.introduction.illustrationUrl"
               alt="product gallery page"
               class="illustration"
            />
         </div>
         <p class="product__description">
            {{ descriptionJoiner(pageData.introduction.description) }}
         </p>
         <div class="product__ctas">
            <a
               class="btn btn-primary-grad product__ctas-btn product__ctas-btn-download"
               :href="pageData.introduction.ctas[0].link"
               @click.prevent="goTo(pageData.introduction.ctas[0].link)"
            >
               {{ pageData.introduction.ctas[0].header }}
            </a>
            <a
               class="btn btn-outline-primary product__ctas-btn"
               :href="pageData.introduction.ctas[1].link"
               >{{ pageData.introduction.ctas[1].header }}</a
            >
         </div>
      </div>
      <!--Chart Show Case-->
      <!--
      <div class="chart-show-case">
         <div class="main-content-block">
            <h2 class="text-center heading">
               {{ pageData.demo.header }}
            </h2>
            <mq-layout v-if="isClient" :mq="['xs', 'sm']">
               <div class="row">
                  <div class="col-12 text-center pt-1 pb-6">
                     <BaseDropDown
                        v-model="selectedTab"
                        class="base-drop-down"
                        placeholder="Choose Chart type"
                        :options="chartTypesData"
                     />
                  </div>
               </div>
            </mq-layout>
            <mq-layout v-if="isClient" mq="md+">
               <div class="tab-header mb-1">
                  <div ref="sliderBox" class="slider-box">
                     <div ref="tabSwiper" v-swiper="tabSwiperOptions">
                        <div class="swiper-wrapper">
                           <div
                              v-for="(item, index) in chartTypes"
                              :key="index"
                              :class="[
                                 'swiper-slide tab-item',
                                 {
                                    active: index === selectedIndex,
                                 },
                              ]"
                              @click.prevent="selectedIndex = index"
                           >
                              <span>{{ item.header }}</span>
                           </div>
                        </div>
                     </div>
                     <div class="swiper-button-next">
                        <i class="fc_keyboard_arrow_right" />
                     </div>
                     <div class="swiper-button-prev">
                        <i class="fc_keyboard_arrow_left" />
                     </div>
                  </div>
               </div>
            </mq-layout>

            <ChartView
               :html-code="selectedChartType.code.htmlCode"
               :js-code="selectedChartType.code.jsCode"
               :css-code="selectedChartType.code.cssCode"
               :seo-img-url="selectedChartType.preview"
               :seo-img-alt="selectedChartType.header"
               :product="selectedChartType.product"
               :show-themes="true"
            />
         </div>

         <a
            :href="pageData.demo.ctas[0].link"
            class="btn btn-primary-grad chart-show-case-btn"
            @click.prevent="goTo(pageData.demo.ctas[0].link)"
         >
            {{ pageData.demo.ctas[0].header }}
         </a>
      </div>--->

      <!----->

      <!--What do you get with FusionCharts Suite XT-->
      <div class="product-suite">
         <Card
            :text-align="true"
            :content="pageData.fusionChartsSuite"
            :required-font-icon="true"
            :required-four-columns-per-row="true"
            :adjust-margin="true"
         />
      </div>

      <!--Why Our Customers love FusionCharts-->
      <div class="customers-love">
         <Card
            :content="pageData.loveFusionCharts"
            :vertical-card="true"
            :required-four-columns-per-row="true"
            :text-align="true"
         />
         <a
            class="btn btn-primary-grad customers-love__cust-btn"
            :href="pageData.loveFusionCharts.ctas[0].link"
            @click.prevent="goTo(pageData.loveFusionCharts.ctas[0].link)"
         >
            {{ pageData.loveFusionCharts.ctas[0].header }}
         </a>
      </div>

      <!-- Technology Section -->
      <div class="framework-integrations">
         <IntegrateWithFrameworkEasily :config="productGalleryPageData.frameworkIntegrations" />
      </div>

      <!--ProductComparison-->
      <ProductComparison :content="productGalleryPageData.comparison" />

      <!--Testimonial-->
      <div class="testimonial-section">
         <SimpleTestimonial :content="pageData.testimonial" />
      </div>

      <!--More Products-->
      <div class="more-products">
         <Card
            :content="pageData.moreProducts"
            :text-align="true"
            :required-font-icon="true"
            cta-name="learn more"
            :adjust-margin="true"
            :special-header-font="true"
         />
      </div>

      <!--GetStarted-->
      <!--<div class="get-started">
         <h2 class="get-started__heading">{{ pageData.getStarted.header }}</h2>
         <div class="get-started__ctas">
            <a
               v-if="
                  pageData.getStarted &&
                     pageData.getStarted.ctas[0] &&
                     pageData.getStarted.ctas[0].link
               "
               :href="pageData.getStarted.ctas[0].link"
               class="btn btn-primary-grad get-started__ctas-btn"
               @click.prevent="goTo(pageData.getStarted.ctas[0].link)"
               >{{ pageData.getStarted.ctas[0].header }}</a
            >
            <a
               v-if="
                  pageData.getStarted &&
                     pageData.getStarted.ctas[1] &&
                     pageData.getStarted.ctas[1].link
               "
               :href="pageData.getStarted.ctas[1].link"
               class="btn btn-outline-primary get-started__ctas-btn"
               @click.prevent="goTo(pageData.getStarted.ctas[1].link)"
               >{{ pageData.getStarted.ctas[1].header }}</a
            >
            <button
               v-if="
                  pageData.getStarted &&
                     pageData.getStarted.ctas[2] &&
                     pageData.getStarted.ctas[2].link
               "
               class="btn btn-outline-primary get-started__ctas-btn"
               @click="modalShowContactSales = !modalShowContactSales"
            >
               {{ pageData.getStarted.ctas[2].header }}
            </button>
         </div>
      </div>-->

      <!--Contact Sales Modal Component-->
      <b-modal v-model="modalShowContactSales" centered hide-footer>
         <ContactSales :purpose-options="purpose_options" />
      </b-modal>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import metaGenerator from '../util/meta.js';
// import BaseDropDown from '../components/core/BaseDropdown';
// import ChartView from '../components/playground/ChartView.vue';
import Card from '../components/core/Card';
import SimpleTestimonial from '../components/core/SimpleTestimonial';
import IntegrateWithFrameworkEasily from '../components/core/IntegrateWithFrameworkEasily';
import ContactSales from '../components/elforms/Sales';
import ProductComparison from '../components/home/ProductComparison';

export default {
   name: 'ProductGallery',
   components: {
      // BaseDropDown,
      // ChartView,
      Card,
      SimpleTestimonial,
      IntegrateWithFrameworkEasily,
      ContactSales,
      ProductComparison,
   },
   data() {
      return {
         modalShowContactSales: false,
         purpose_options: [
            {
               value: 'saas-quote',
               text: 'Licensing query for a SaaS application',
            },
            {
               value: 'oem-quote',
               text: 'Licensing query for an on-premise application (OEM)',
            },
            {
               text: 'Licensing query for an enterprise plan',
               value: 'licensing-query-for-an-enterprise-plan',
            },
            {
               text: 'Reseller enquiry',
               value: 'reseller-enquiry',
            },
            {
               value: 'licensing-fusionexport',
               text: 'Licensing FusionExport',
            },
            { value: 'offline-payment', text: 'Payment through PO/Wire/Check' },
            { value: 'product-technical-query', text: '​Product/Technical related query' },
            { value: 'other', text: 'Other' },
         ],
         selectedChartType: { code: {}, preview: null, header: null },
         selectedTab: null,
         selectedIndex: 0,
         breakpoints: {
            small: 992,
         },
         tabSwiperOptions: {
            slidesPerView: 'auto',
            slidesPerGroup: 5,
            spaceBetween: 0,
            freeMode: true,
            navigation: {
               nextEl: '.swiper-button-next',
               prevEl: '.swiper-button-prev',
            },
         },
         isClient: false,
      };
   },
   computed: {
      ...mapState(['productGalleryPageData']),
      pageData() {
         return this.productGalleryPageData;
      },

      // start
      /* chartTypes() {
        return this.pageData.demo.tabs;
      }, */
      chartTypesData() {
         const data = [];
         for (let i = 0, ii = this.pageData.demo.tabs.length; i < ii; i++) {
            data.push({
               text: this.pageData.demo.tabs[i].header,
               value: this.pageData.demo.tabs[i].header,
            });
         }
         return data;
      },
      // end
   },
   metaInfo() {
      return metaGenerator(this.productGalleryPageData);
   },
   // start
   watch: {
      /* selectedTab(val) {
         for (let i = 0, ii = this.chartTypes.length; i < ii; i++) {
            if (this.chartTypes[i].header === val) {
               if (i !== this.selectedIndex) {
                  this.selectedIndex = i;
               }
               break;
            }
         }
      },
      selectedIndex(val) {
         this.selectedTab = this.chartTypes[val].header;
         this.selectedChartType = this.chartTypes[val];
      }, */
   },
   // end
   asyncData({ store }) {
      return Promise.all([store.dispatch('PRODUCT_GALLERY_DATA_FETCH')]);
   },

   mounted() {
      // start
      this.isClient = true;
      // eslint-disable-next-line
      //this.selectedChartType = this.chartTypes[0];
      // end
      this.setImageHeight();
      window.addEventListener('resize', this.setImageHeight);
   },
   methods: {
      goTo(url) {
         this.$router.push(url).catch(err => {});
      },
      setImageHeight() {
         if (this.$refs.setImageHeight && this.$refs.setImageHeight.style) {
            this.$refs.setImageHeight.style.setProperty('--custHeight', `${228}px`);
         }
         const eleProperties = getComputedStyle(this.$refs.productEleHeight);
         // eslint-disable-next-line radix
         const paddingTop = parseInt(eleProperties.paddingTop);
         // eslint-disable-next-line radix
         const paddingBottom = parseInt(eleProperties.paddingBottom);
         // eslint-disable-next-line radix
         const elementHeight = parseInt(eleProperties.height);

         const actualHeight = elementHeight - (paddingTop + paddingBottom);

         this.$refs.setImageHeight.style.setProperty('--custHeight', `${actualHeight}px`);
      },
   },
};
</script>

<style lang="scss" scoped>
.product-gallery-page {
   overflow: hidden;
   background-color: #f9f9fb;
   width: 100%;
   // No top padding: PrimaryNavigation.vue's spacer already reserves the
   // fixed header's height. The old 54px here was left over from before
   // that spacer existed and just left an empty band above the hero.
   padding: 0;
   .product {
      /*background-color: #ffffff;aa*/
      @media (min-width: 250px) {
         padding: 36px 15px 60px 15px;
      }
      @media (min-width: 576px) and (max-width: 799px) {
         padding: 37px 38px 60px 38px;
      }
      @media (min-width: 800px) and (max-width: 992px) {
         padding: 47px 49px 60px 49px;
      }
      @media (min-width: 992px) {
         padding: 63px 51px 67px 51px;
      }
      @media (min-width: 1371px) {
         overflow: auto;
      }
      &__heading {
         text-align: center;
         line-height: 48px;
         margin: 0;
         @media (min-width: 576px) {
            text-align: left;
         }
         @media (min-width: 800px) {
            display: inline-block;
         }
      }
      &__image {
         padding: 88px 0 47px 0;
         height: 100%;
         width: 100%;
         display: flex;
         justify-content: center;
         @media (min-width: 800px) {
            --custHeight: 358px;
            float: right;
            padding: 0;
            width: 304px;
            margin-left: 30px;
            height: var(--custHeight, 358px);
         }
         @media (min-width: 992px) {
            float: none;
            width: 100%;
            height: 100%;
            padding: 88px 0 47px 0;
            margin-left: 0;
         }
         @media (min-width: 1190px) {
            --custHeight: 306px;
            float: right;
            padding: 0;
            width: auto;
            margin-left: 30px;
            height: var(--custHeight, 306px);
         }
         .illustration {
            height: 154px;
            width: 200px;
            @media (min-width: 576px) and (max-width: 799px) {
               width: 304px;
               height: 218px;
            }
            @media (min-width: 800px) {
               width: 100%;
               height: 100%;
            }
            @media (min-width: 992px) {
               width: 304px;
               height: 218px;
            }
            @media (min-width: 1190px) {
               width: 100%;
               height: 100%;
            }
         }
      }
      &__description {
         line-height: 26px;
         letter-spacing: 0.23px;
         color: #4a4a4a;
         margin: 8px 0 24px 0;
         @media (min-width: 1448px) {
            width: 592px;
         }
      }
      &__ctas {
         display: flex;
         justify-content: center;
         @media (min-width: 250px) and (max-width: 360px) {
            flex-direction: column;
            align-items: center;
         }
         @media (min-width: 800px) {
            justify-content: flex-start;
         }
         &-btn {
            padding: 13px 24px;
            line-height: 16px;
         }
         &-btn-download {
            margin-right: 20px;
            @media (min-width: 250px) and (max-width: 360px) {
               margin: 0 0 15px 0;
            }
            @media (min-width: 360px) {
               margin-right: 11.99px;
            }
         }
      }
   }

   .chart-show-case {
      @media (max-width: 373px) {
         padding: 80px 15px 0 15px;
      }
      @media (min-width: 374px) {
         padding: 80px 30px 0 30px;
      }
      @media (min-width: 577px) {
         padding: 80px 38px 0 38px;
      }
      @media (min-width: 1199px) {
         padding: 60px 38px 0 38px;
      }
      .heading {
         width: auto;
         letter-spacing: 0.43px;
         text-align: center;
         line-height: 38px;
         margin: 0 auto;
         margin-bottom: 36px;
         @media (max-width: 769px) {
            line-height: 33px;
         }
         @media (min-width: 1325px) {
            width: 888px;
         }
      }
      .chart-show-case-btn {
         padding: 9.5px 9px;
         font-size: 14px;
         width: 284.5px;
         margin: 55px auto 0 auto;
         display: block;
         @media (min-width: 375px) {
            width: 305px;
            font-size: 15px;
         }
         @media (min-width: 577px) {
            width: 325px;
         }
      }
   }
   .customers-love {
      @media (max-width: 373px) {
         padding: 80px 15px 0 15px;
      }
      @media (min-width: 374px) {
         padding: 80px 30px 0 30px;
      }
      @media (min-width: 577px) {
         padding: 80px 38px 0 38px;
      }
      @media (min-width: 1199px) {
         padding: 121px 38px 0 38px;
      }
      &__cust-btn {
         padding: 13px 24px;
         line-height: 16px;
         letter-spacing: 0.2px;
         font-size: 15px;
         color: #ffffff;
         display: block;
         width: 314px;
         margin: 55px auto 0 auto;
         @media (max-width: 373px) {
            width: 290px;
            padding: 13px 11px;
         }
         &:hover {
            color: #ffffff;
         }
      }
   }

   .product-suite {
      @media (max-width: 373px) {
         padding: 80px 15px 0 15px;
      }
      @media (min-width: 374px) {
         padding: 80px 30px 0 30px;
      }
      @media (min-width: 577px) {
         padding: 80px 38px 0 38px;
      }
      @media (min-width: 992px) {
         padding: 80px 38px 0 38px;
      }
      &__heading {
         text-align: center;
         margin-bottom: 36px;
      }
   }
   .framework-integrations {
      @media (max-width: 373px) {
         padding: 80px 15px 0 15px;
      }
      @media (min-width: 374px) {
         padding: 80px 30px 0 30px;
      }
      @media (min-width: 577px) {
         padding: 80px 38px 0 38px;
      }
   }
   .testimonial-section {
      padding: 0 15px;
      margin-top: 0;
      @media (min-width: 374px) {
         padding: 0 30px;
      }
      @media (min-width: 577px) {
         padding: 0 38px;
      }
      @media (min-width: 1199px) {
         margin-top: 0;
      }
   }
   .more-products {
      @media (max-width: 373px) {
         padding: 80px 15px 0 15px;
      }
      @media (min-width: 374px) {
         padding: 80px 30px 0 30px;
      }
      @media (min-width: 577px) {
         padding: 80px 38px 0 38px;
      }
      @media (min-width: 1199px) {
         padding: 121px 38px 0 38px;
      }
   }
   .get-started {
      @media (max-width: 373px) {
         padding: 80px 15px 0 15px;
         margin-bottom: 75px;
      }
      @media (min-width: 374px) {
         padding: 80px 30px 0 30px;
         margin-bottom: 75px;
      }
      @media (min-width: 577px) {
         padding: 80px 38px 0 38px;
         margin-bottom: 75px;
      }
      &__heading {
         text-align: center;
         margin: 0;
      }
      &__ctas {
         display: flex;
         flex-direction: column;
         align-items: center;
         margin-top: 36px;
         @media (min-width: 577px) {
            flex-direction: row;
            justify-content: center;
         }
         &-btn {
            margin-bottom: 25px;
            width: 166px;
            padding: 13px 24px;
            line-height: 16px;
            @media (min-width: 577px) {
               width: auto;
               margin-right: 18px;
            }
            &:nth-last-child(-n + 1) {
               @media (min-width: 577px) {
                  margin-right: 0;
               }
            }
         }
      }
   }
}

// chart css
.fusion-time {
   .base-drop-down {
      width: 100%;
      margin-bottom: 20px;
   }
   &.bg-light-purple {
      background: linear-gradient(
         to bottom,
         rgba(255, 255, 255, 1) 10%,
         rgba(248, 249, 253, 1) 16%,
         rgba(248, 249, 253, 1) 49%,
         rgba(248, 249, 253, 1) 87%,
         rgba(255, 255, 255, 1) 100%
      );
   }

   .tab-header {
      display: flex;
      align-items: center;
      span,
      .swiper-slide {
         color: #73748c;
         font-size: 12px;
         font-weight: 600;
         letter-spacing: 0.15px;
         line-height: 15px;
      }

      .swiper-container {
         margin: 0 0;
      }

      .swiper-slide {
         text-align: center;
         min-width: 130px;
      }
      @media (min-width: 1200px) {
         .swiper-slide {
            min-width: 156px;
         }
      }
      .slider-box {
         max-width: auto !important;
         width: 100%;
         display: inline-block;
      }
      span {
         display: inline-block;
      }

      .quick-demo {
         width: 100px;
      }
   }

   .chart-type-swiper-wrapper {
      //max-width: 53vw;
      max-width: 82vw;
   }

   .chart-type-swiper-header {
      flex: 0 0 auto;
      margin-right: 10px;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 600;
      color: #73748c;
   }

   .chart-type-swiper-wrapper {
      flex: 1 1 auto;
      overflow: hidden;
      // max-width: 50vw;
      @media (min-width: 992px) {
         // max-width: 50vw;
         max-width: 57vw;
      }
      @media (min-width: 1150px) {
         max-width: 64vw;
      }
      @media (min-width: 1400px) {
         //max-width: 56.5vw;
         max-width: 69vw;
      }
      @media (min-width: 1700px) {
         max-width: 71.8vw;
      }

      .swiper-button-next {
         top: 42px;
      }
   }
}

.slider-box {
   border-radius: 6px;
   overflow: hidden;
   position: relative;

   .swiper-wrapper {
      padding-bottom: 5px;
      .tab-item {
         cursor: pointer;
         width: auto !important;
         padding: 8px 12px;
         color: #73748c;
         margin-right: 10px;
         background-color: #ffffff;
         overflow: hidden;
         box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.13);
         border-radius: 4px;

         span {
            margin-left: 5px;
            letter-spacing: 0.4px;
            line-height: 19px;
            font-size: 15px;
         }
         &:hover {
            color: #6957da;
         }
         &.active {
            span {
               color: #ffffff;
            }
            background-color: #6957da;
         }
      }
   }
}

.swiper-button-next,
.swiper-button-prev {
   height: 25px;
   width: 25px;
   background: #fff;
   border-radius: 50%;
   box-shadow: 0 2px 4px 0 rgba(104, 105, 128, 0.22);
   top: 68%;
}

.swiper-button-prev {
   left: 0;
}
.swiper-button-next {
   right: 0;
}

.swiper-wrapper {
   max-width: 1000px;
   width: auto;
   margin: 0;
}
</style>

<style lang="scss">
.custom-text-position {
   text-align: center;
   width: 600px;
   margin: 0 auto 10px auto;
   @media (max-width: 1198px) {
      width: auto;
   }
   @media (min-width: 1199px) {
      margin: 0 auto 32px auto;
   }
}
</style>
